import { Switch, Route, useLocation } from 'react-router-dom';
import { MainLayout } from '@/layouts';
import { Home, PageNotFound, AppDetail } from '@/pages';
import { useEffect } from 'react';
import { User } from '@/shared';

export const RouteConfig = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(window.pageXOffset, 0);
  }, [location]);

  return (
    <Switch>
      <Route exact path={['/app-detail', '/']}>
        <MainLayout>
          <Switch>
            <Route exact path={'/'} component={Home} />
            <Route exact path={'/app-detail'} component={AppDetail} />
          </Switch>
        </MainLayout>
      </Route>
      <Route path={'*'} component={PageNotFound} />
    </Switch>
  );
};
